export const getFormattedTime=(dateTimeString:string)=>{
    // const dateTimeObj = new Date(dateTimeString);
          
    //       const time = dateTimeString ? dateTimeObj.toLocaleTimeString() :"--"
    //       return time
    const dateTimeObj = new Date(dateTimeString);

    const options: Intl.DateTimeFormatOptions = { hour: 'numeric', minute: 'numeric', second: 'numeric' };
    const time = dateTimeString ? dateTimeObj.toLocaleTimeString(undefined, options).replace(/:\d{2}\s/, ' ') : "--";

    return time;
  }
 export const getFormattedDate=(dateTimeString:string)=>{
    const dateTimeObj = new Date(dateTimeString);
    const day = dateTimeObj.getDate();
    const monthName = dateTimeObj.toLocaleString('default', { month: 'short' });
    const year = dateTimeObj.getFullYear();
  
    const formattedDate = dateTimeString ? `${day} ${monthName} ${year}` : "--"
    return formattedDate
  }

  // utils/dateFormatter.ts

export const formatDateTime = (dateString: string): string => {
  if (!dateString) return "";

  const date = new Date(dateString);

  const dateOptions: Intl.DateTimeFormatOptions = {
    day: "numeric",
    month: "short",
    year: "numeric",
    timeZone: "Asia/Kolkata",
  };

  const timeOptions: Intl.DateTimeFormatOptions = {
    hour: "numeric",
    minute: "numeric",
    hour12: true,
    timeZone: "Asia/Kolkata",
  };

  const formattedDate = date.toLocaleDateString("en-GB", dateOptions); // 7 Apr 2025
  const formattedTime = date.toLocaleTimeString("en-GB", timeOptions); // 2:35 PM

  return `${formattedDate} | ${formattedTime}`;
};
